import React from "react";
import creditIcon from "../assets/icons/credit-icon.svg";
import { MORATORIUM_BODY_COPY, MORATORIUM_TITLE } from "./moratoriumCopy";

interface MoratoriumTileProps {
  innerRef?: React.Ref<HTMLDivElement>;
  isHighlighted?: boolean;
}

const MoratoriumTile: React.FC<MoratoriumTileProps> = ({
  innerRef,
  isHighlighted = false,
}) => {
  return (
    <div
      ref={innerRef}
      className={`mb-6 md:flex-1 ${
        isHighlighted ? "border-4 border-primary rounded-20 p-2" : ""
      }`}
    >
      <div className="flex mb-3">
        <img alt="credit icon" src={creditIcon} />
        <h2 className="text-2xl ml-2.5">{MORATORIUM_TITLE}</h2>
      </div>
      <div className="container-white-rounded">
        <p className="mt-2">{MORATORIUM_BODY_COPY}</p>
      </div>
    </div>
  );
};

export default MoratoriumTile;
